import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
export var createNoneAudioDestinationNodeConstructor = function createNoneAudioDestinationNodeConstructor(audioNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_audioNodeConstructor) {
      _inherits(NoneAudioDestinationNode, _audioNodeConstructor);

      function NoneAudioDestinationNode(context, internalState, nativeAudioNode, audioNodeRenderer) {
        _classCallCheck(this, NoneAudioDestinationNode);

        return _possibleConstructorReturn(this, _getPrototypeOf(NoneAudioDestinationNode).call(this, context, internalState, nativeAudioNode, audioNodeRenderer));
      }

      return NoneAudioDestinationNode;
    }(audioNodeConstructor)
  );
};